import { LINK_MAP } from '../config';

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const EMAIL = '[\\w.+-]+@[\\w-]+(?:\\.[\\w-]+)+';

let map = { ...LINK_MAP };
let pattern = build(map);

function build(links) {
  const names = Object.keys(links).sort((a, b) => b.length - a.length).map(escape);
  return new RegExp(`(${[...names, EMAIL].join('|')})`, 'g');
}

/** Names that turn into links in sheet text: config.js defaults plus the sheet's AUTO LINKS block. */
export function setAutoLinks(extra = {}) {
  map = { ...LINK_MAP, ...extra };
  pattern = build(map);
}

export const getAutoLinks = () => ({ map, pattern });
